import { Table } from 'antd';
import {
  DISPLAY_EMPTY,
  MANAGEMENT_SEAL_REQUEST_CONSTANT,
  TSealRequestRow,
} from '../constant';
import { SealRequestModalWrapper } from '../ManagementSealRequestStyled';

const { LABEL, DIALOG_SEND_CONFIRM } = MANAGEMENT_SEAL_REQUEST_CONSTANT;

type TSendConfirmDialogProps = {
  open: boolean;
  loading: boolean;
  row: TSealRequestRow | null;
  newQuantity: number | null;
  onCancel: () => void;
  onOk: () => void;
};

const columns = [
  {
    title: DIALOG_SEND_CONFIRM.COLUMN_LABEL,
    dataIndex: 'label',
    key: 'label',
    width: '40%',
  },
  { title: DIALOG_SEND_CONFIRM.COLUMN_VALUE, dataIndex: 'value', key: 'value' },
];

function formatStore(row: TSealRequestRow | null): string {
  if (!row || (!row.storeCode && !row.storeName)) {
    return DISPLAY_EMPTY;
  }

  return `${row.storeCode || ''} ${row.storeName || ''}`.trim();
}

// VAMS_PC_008_02 (送信確認ダイアログ) — opened from 送信 [D8] of Dialog D (dialog lồng dialog).
export function SendConfirmDialog({
  open,
  loading,
  row,
  newQuantity,
  onCancel,
  onOk,
}: TSendConfirmDialogProps) {
  const summaryRows = [
    {
      key: 'store',
      label: DIALOG_SEND_CONFIRM.ROW_STORE,
      value: formatStore(row),
    },
    {
      key: 'assetNo',
      label: DIALOG_SEND_CONFIRM.ROW_ASSET_NO,
      value: row?.assetNo || DISPLAY_EMPTY,
    },
    {
      key: 'assetName',
      label: DIALOG_SEND_CONFIRM.ROW_ASSET_NAME,
      value: row?.assetName || DISPLAY_EMPTY,
    },
    {
      key: 'quantity',
      label: DIALOG_SEND_CONFIRM.ROW_QUANTITY,
      value:
        newQuantity === null || newQuantity === undefined
          ? DISPLAY_EMPTY
          : `${newQuantity}${LABEL.UNIT_SHEETS_SUFFIX}`,
    },
  ];

  return (
    <SealRequestModalWrapper
      open={open}
      title={DIALOG_SEND_CONFIRM.TITLE}
      maskClosable={false}
      confirmLoading={loading}
      onCancel={onCancel}
      cancelText={DIALOG_SEND_CONFIRM.BTN_CANCEL}
      okText={DIALOG_SEND_CONFIRM.BTN_OK}
      cancelButtonProps={{ disabled: loading }}
      okButtonProps={{ disabled: loading }}
      onOk={onOk}
      width={560}
      destroyOnClose
    >
      <p className="seal-request-dialog_message">
        {DIALOG_SEND_CONFIRM.MESSAGE}
      </p>

      <Table
        dataSource={summaryRows}
        columns={columns}
        pagination={false}
        size="small"
        bordered
      />
    </SealRequestModalWrapper>
  );
}
